import React, { useState } from 'react';
import Modal from 'react-modal';
import ConfirmCancellationModal from './ConfirmCancellationModal';

const CancelEventModal = ({ isOpen, closeModal, eventData, addons, chosenPackage }) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const reasons = [
    'Client requested a cancellation',
    'Vendor unable to fulfill the event',
    'Other',
  ];

  const handleSubmit = () => {
    // Close CancelEventModal
    closeModal();
    // Open ConfirmCancellationModal
    setShowConfirmModal(true);
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal-content"
        style={{
          content: {
            width: '570px',
            height: '600px',
            margin: 'auto',
            padding: '30px',
          },
        }}
      >
        <span className="close" onClick={closeModal}>&times;</span>

        <h2 style={{ fontWeight: 'bold', fontSize: '20px', marginBottom: '20px' }}>
          Why do you want to cancel the event?
        </h2>

        <p style={{ color: '#625C73', fontSize: '15px' }}>
          To ensure clear communication and transparency, please select the reason for canceling this event. This information will be shared with the client to explain the cancellation and help manage their expectations:
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px' }}>
          {reasons.map((reason, index) => (
            <div
              key={index}
              onClick={() => setSelectedReason(reason)}
              style={{
                padding: '12px 15px',
                border: selectedReason === reason ? '2px solid #2a1980' : '1px solid #ccc',
                borderRadius: '8px',
                cursor: 'pointer',
                backgroundColor: '#fff',
                transition: 'all 0.3s ease',
                fontSize: '14px',
              }}
            >
              {reason}
            </div>
          ))}
        </div>

        <p style={{ color: '#625C73', fontSize: '15px' }}>Write what's the reason for cancelling</p>

        <textarea
          placeholder="Additional reason (optional)..."
          value={customReason}
          onChange={(e) => setCustomReason(e.target.value)}
          style={{
            width: '97%',
            height: '80px',
            padding: '10px',
            fontSize: '14px',
            border: '1px solid #ccc',
            borderRadius: '8px',
            resize: 'none',
            marginBottom: '20px',
          }}
        />

        <div style={{ textAlign: 'right' }}>
          <button
            onClick={handleSubmit}
            style={{
              background: 'transparent linear-gradient(90deg, #1C1154 0%, #211074 47%, #260F99 100%)',
              border: '1px solid #43425D',
              borderRadius: '4px',
              color: '#FFFFFF',
              fontSize: '15px',
              cursor: 'pointer',
              width: '210px',
              height: '45px',
            }}
          >
            Submit
          </button>
        </div>
      </Modal>

      {/* ConfirmCancellationModal is rendered separately here */}
      <ConfirmCancellationModal
        isOpen={showConfirmModal}
        closeModal={() => setShowConfirmModal(false)}
        eventData={eventData}
        addons={addons}
        chosenPackage={chosenPackage}
        reason={selectedReason + (customReason ? ` - ${customReason}` : '')}
      />
    </>
  );
};

export default CancelEventModal;
